import { post, request } from "~/core/api/index";

/** One field of the form a paused workflow asks a person to fill in. */
export interface FieldSchema {
	type?: string;
	title?: string;
	description?: string;
	default?: unknown;
	enum?: unknown[];
}
export interface FormSchema {
	type: "object";
	properties?: Record<string, FieldSchema>;
	required?: string[];
}

/** A native Agent workflow run paused on a human step assigned to the viewer. */
export interface InboxItem {
	context_id: string;
	workflow_id: string;
	execution_id: string;
	entity_id: string;
	brand: string;
	workflow_name: string;
	block_id: string;
	title: string | null;
	description: string | null;
	deadline: string;
	created_at: string;
	approval: boolean;
	schema: FormSchema;
}

export interface Estimate {
	basis: string;
	reference_credits: number | null;
	complete: boolean;
	known_reference_credits: number;
	lines: {
		label: [string, string];
		capability: string;
		fee: string;
		max_invocations: number;
		observations: number;
		mean_credits: number | null;
		reference_credits: number | null;
	}[];
}

/** Dispatched after a response, so the inbox and the sidebar badge drop the item without waiting for the poll. */
export const AGENT_INBOX_CHANGED = "ondit:agent-inbox-changed";

export const agents = {
	inbox: (org: string) => request<{ items: InboxItem[] }>(`/orgs/${org}/agent-inbox`),
	respond: (item: Pick<InboxItem, "workflow_id" | "execution_id" | "context_id">, input: Record<string, unknown>) =>
		post<{ status: string; success: boolean; executionId: string }>(
			`/agent/resume/${item.workflow_id}/${item.execution_id}/${item.context_id}`,
			{ input },
		),
	/** Capability ids, repeated once per invocation. */
	estimate: (entity: string, capabilities: string[]) =>
		post<Estimate>(`/entities/${entity}/capability-estimate`, { capabilities }),
};
